import { analytics } from '@/lib/analytics/analytics';
import * as Logger from '@/lib/monitoring/logger';
import { getCurrentUser } from '@/services/internal-api/core/auth-config';

export async function identifyCurrentUser() {
  try {
    const user = await getCurrentUser();
    if (user?.attributes?.sub) {
      analytics.identify(user.attributes.sub, {
        userId: user.attributes.sub,
        email: user.attributes.email,
        firstName: user.attributes.name,
        lastName: user.attributes.family_name,
      });
    }
    return user;
  } catch (e) {
    Logger.error('failed to identify current user', e instanceof Error ? e : null, { error: e });
    return null;
  }
}
